import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/Step/Columns';
import { STORAGE_KEYS } from '../../utils/localStorageKeys';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

export const StepsDataGrid = ({ data, handleEdit }: IDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'Step.List';
  const history = useHistory();
  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Steps', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => history.push(`/steps/new/`),
        },
      },
    );
  };
  return (
    <SisDataGrid
      data={data}
      keyExpr={'id'}
      transFormName={transFormName}
      columns={Columns(handleEdit, translate)}
      onCellDblClick={(e) => handleEdit && handleEdit(e)}
      columnChooser={false}
      allowColumnResizing={false}
      allowColumnReordering={false}
      onToolbarPreparing={onToolbarPreparing}
      pageSizeChangeVisible
      stateStoringKey={STORAGE_KEYS.STEP_DATAGRID}
    />
  );
};
